const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    marginBottom: theme.spacing.unit * 2,
    padding: theme.spacing.unit * 2,
    boxShadow: 'none',
    borderTop: '1px solid #DCDDDE',
    borderBottom: '1px solid #DCDDDE',
  },
  searchBox: {
    width: '100%',
    fontSize: theme.typography.headline.fontSize,
  },
  flex: {
    flex: 1
  },
  // searchBox: {
  //   border: 'none',
  //   borderBottom: '2px solid #025794',
  //   background: 'none',
  //   width: '100%',
  //   fontSize: '1rem',
  //   lineHeight:  '30px',
  // }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/search/styles.js